import { render, staticRenderFns } from "./tkCabin.vue?vue&type=template&id=7ad06d52&scoped=true"
import script from "./tkCabin.vue?vue&type=script&lang=js"
export * from "./tkCabin.vue?vue&type=script&lang=js"
import style0 from "./tkCabin.vue?vue&type=style&index=0&id=7ad06d52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad06d52",
  null
  
)

export default component.exports